import React from 'react'
import Navbar from './Navbar'
import { Button, Card, Grid2, Typography } from '@mui/material'
import { ArrowForward, Person } from '@mui/icons-material'
import { Link } from 'react-router-dom'


export default function Admin() {
  const [fetchSpamData, setFetchSpamData] = React.useState([]);
  const [fetchCatalogsData, setFetchCatalogsData] = React.useState([]);
  const [fetchShopData, setFetchShopData] = React.useState([]);

  const fetchSpamLists = () => {
    const token = localStorage.getItem('accessToken');
    // fetch(`https://api.adoop.in/api/v2/shop_promotion/promotion_status/SPAM`, {
       fetch(`https://api.adoop.in/api/v2/shop_promotion/promotion_status/ALL`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setFetchSpamData(data);  // Update the state with the fetched data
      })
      .catch((error) => console.error(error));
  };

  // Call the function to fetch data on component mount
  React.useEffect(() => {
    fetchSpamLists();
    fetchCatalogsLists();
    fetchShopkeeperLists();
  }, []);

 // Fetch the catalog list data
 const fetchCatalogsLists = () => {
  const token = localStorage.getItem('accessToken');
  fetch(`https://api.adoop.in/api/v2/catalogs`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      setFetchCatalogsData(data);  // Update the state with the fetched data
    })
    .catch((error) => console.error(error));
};



// Fetch the shopkeeper list data
const fetchShopkeeperLists = () => {
  const token = localStorage.getItem('accessToken');
  fetch(`https://api.adoop.in/api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      setFetchShopData(data);  // Update the state with the fetched data
    })
    .catch((error) => console.error(error));
};

  return (
    <div>
        <Navbar/>
        <Grid2 container style={{ display: "flex", justifyContent:'space-evenly', margin:"20px" }}>
        <Grid2 lg={3} md={3} sm={6} xs={12}>
          <Card
            sx={{ maxWidth: 245 }}
            style={{
              background: "lightyellow",
              marginBottom: "5px",
              color: "black",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "20px",
                width: "200px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography gutterBottom variant="h5" component="div">
                  {fetchShopData.length}
                </Typography>
                <Typography gutterBottom variant="body1" component="div">
                  Total Shopkeepers
                </Typography>
              </div>
              <Person sx={{ fontSize: 60 }} style={{color:"gold"}} />
            </div>
            <Link
              to="/shopkeeper"
              underline="none"
              style={{ color: "white" }}
            >
              <Button variant="contained" style={{backgroundColor:"gold", color:"black"}} fullWidth>
                More Info{" "}
                <ArrowForward
                  sx={{ fontSize: 20 }}
                  style={{
                    background: "white",
                    color: "black",
                    borderRadius: "50%",
                  }}
                />
              </Button>
            </Link>
          </Card>
        </Grid2>
        
        
        <Grid2 lg={3} md={3} sm={6} xs={12}>
          <Card
            sx={{ maxWidth: 245 }}
            style={{
              background: "lightyellow",
              marginBottom: "5px",
              color: "black",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "20px",
                width: "200px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography gutterBottom variant="h5" component="div">
                  {fetchCatalogsData.length}
                </Typography>
                <Typography gutterBottom variant="body1" component="div">
                 Total Catalogs
                </Typography>
              </div>
              <Person sx={{ fontSize: 60 }} style={{color:"gold"}} />
            </div>
            <Link
              to="/catalogs"
              underline="none"
              style={{ color: "white" }}
            >
              <Button variant="contained" style={{backgroundColor:"gold", color:"black"}} fullWidth>
                More Info{" "}
                <ArrowForward
                  sx={{ fontSize: 20 }}
                  style={{
                    background: "white",
                    color: "black",
                    borderRadius: "50%",
                  }}
                />
              </Button>
            </Link>
          </Card>
        </Grid2>


        <Grid2 lg={3} md={3} sm={6} xs={12}>
          <Card
            sx={{ maxWidth: 245 }}
            style={{
              background: "lightyellow",
              marginBottom: "5px",
              color: "black",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "20px",
                width: "200px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography gutterBottom variant="h5" component="div">
                  {fetchSpamData.totalElements}
                </Typography>
                <Typography gutterBottom variant="body1" component="div">
                 Total Spam
                </Typography>
              </div>
              <Person sx={{ fontSize: 60 }} style={{color:"gold"}} />
            </div>
            <Link
              to="/spam"
              underline="none"
              style={{ color: "white" }}
            >
              <Button variant="contained" style={{backgroundColor:"gold", color:"black"}} fullWidth>
                More Info{" "}
                <ArrowForward
                  sx={{ fontSize: 20 }}
                  style={{
                    background: "white",
                    color: "black",
                    borderRadius: "50%",
                  }}
                />
              </Button>
            </Link>
          </Card>
        </Grid2>
   
      
      </Grid2>
       
    </div>
  )
}
